

import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderService } from '../services/order.service';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LabelService } from '../services/label.service';
import { PrinterService } from '../printer.service';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-order-list',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslocoModule],
  providers: [DatePipe],
  templateUrl: './order-list.component.html',
  styleUrl: './order-list.component.css'
})
export class OrderListComponent implements OnInit, OnDestroy {
  orders: any[] = [];
  totalOrders: number = 0;
  selectAll: boolean = false;
  loading: boolean = false;
  printing: boolean = false;
  printingMessage: string = '';
  statusSubscription: any;
  printerStatus: any = { status: false };
  dataInicial: string | undefined;
  dataFinal: string | undefined;
  orderId: any;


  constructor(
    private orderService: OrderService,
    private labelService: LabelService,
    private datePipe: DatePipe,
    private printerService: PrinterService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.loadOrders('ready_to_ship');

    // Inicia o monitoramento da impressora e ouve o Subject
    this.statusSubscription = this.printerService.getPrinterStatusListener().subscribe(
      status => {
        this.printerStatus = status;
        console.log('atualizado');
      }
    );
  }

  ngOnDestroy() {
    // Cancela a inscrição quando o componente for destruído
    if (this.statusSubscription) {
      this.statusSubscription.unsubscribe();
    }
  }

  currentPage: number = 1;
  itemsPerPage: number = 10;

  search(): void {

    this.loading = true;

    if (this.orderId) {
      this.orderService.getOrders('all', this.orderId)
        .then(data => {
          if (data) {
            this.orders = data.results;
            this.totalOrders = data.paging.total;
          }
          this.loading = false;
        })
        .catch(error => {
          console.error('Erro ao carregar os pedidos:', error);
          this.loading = false;
        });
    }
  }
  loadOrders(status: string): void {
    this.loading = true;
    this.orderService.getOrders(status)
      .then(data => {
        if (data) {
          this.orders = data.results;
          this.totalOrders = data.paging.total;
        }
        this.loading = false;
      })
      .catch(error => {
        console.error('Erro ao carregar os pedidos:', error);
        this.loading = false;
      });
  }
  onStatusChange(event: any) {
    const selectedValue = event.currentTarget.value;
    debugger;
    this.loadOrders(selectedValue);
  }

  toggleSelection(order: any) {
    order.selected = !order.selected;
  }

  toggleSelectAll() {
    this.orders.forEach(item => {
      item.checked = this.selectAll;
    });
  }

  toggleCheckbox(index: number) {
    this.orders[index].checked = !this.orders[index].checked;
  }

  print() {
    let toPrint = this.orders.filter(x => x.checked === true);
    if (toPrint.length > 0) {
      this.loading = true;
      this.printing = true;
      this.printingMessage = this.transloco.translate('orders.printingLabels', { count: toPrint.length });

      // this.labelService.print(toPrint.map(x => x.shipping.id))
      //   .then(data => {
      //     if (data) {
      //       data.forEach((item: any) => {
      //         let order = this.orders.find(o => o.shipping.id == item.shipmentId);

      //         item.details = [];

      //         order.order_items.forEach((orderItem: any) => {

      //           let title = orderItem.item.title;
      //           let attributes: any[] = [];

      //           if (orderItem.item.variation_attributes) {
      //             orderItem.item.variation_attributes.forEach((attr: any) => {
      //               attributes.push(`${attr.name}: ${attr.value_name}`);
      //             });
      //           }

      //           item.details.push({
      //             title: title,
      //             attributes: attributes,
      //             sku: orderItem.item.seller_sku,
      //             quantity: `${orderItem.requested_quantity.value} ${orderItem.requested_quantity.measure}`
      //           })

      //           item.manufacturing_ending_date = this.datePipe.transform(order.manufacturing_ending_date, 'dd/MM/yyyy HH:mm');

      //         });


      //         item.zebraCode += this.getZebraCodeFor(item);
      //       })
      //     }
      //     data.forEach((item: any) => {
      //       this.sendToZebraPrinter(item.zebraCode);
      //     });
      //     this.loading = false;
      //     this.printing = false;
      //   })
      //   .catch(error => {
      //     console.error('Erro ao imprimir:', error);
      //     this.loading = false;
      //     this.printing = false;
      //   });
    }
  }

  getZebraCodeFor(item: any): string {

    let zebraCode = '\n^XA'
      + '\n^FWR';

    let count = 0;
    let spacement = 750;
    item.details.forEach((detail: any) => {
      zebraCode += `\n^FO${spacement},50^A0,25,20^FD1${detail.title}^FS`;

      detail.attributes.forEach((attr: any) => {
        spacement -= 25;
        zebraCode += `\n^FO${spacement},50^A0,25,20^FD${attr}^FS`;
      });

      spacement -= 25;
      zebraCode += `\n^FO${spacement},50^A0,25,20^FDSKU: ${detail.sku}^FS`;
      spacement -= 25;
      zebraCode += `\n^FO${spacement},50^A0,25,20^FDQT: ${detail.quantity}^FS`;
      spacement -= 10;
      zebraCode += `\n^FO${spacement},45^GB2,150,2^FS`;
      spacement -= 40;

    });

    zebraCode += `\n^FO${spacement},50^A0,25,20^FDLT: ${item.manufacturing_ending_date}^FS`;
    zebraCode += '\n^XZ';

    return zebraCode;
  }

  sendToZebraPrinter(zebraCode: any): any {
    // Verificar se o usuário está logado
    const token = localStorage.getItem('jwt') || localStorage.getItem('jwt-password');
    if (!token) {
      console.warn('Tentativa de impressão sem autenticação. Usuário não está logado.');
      return Promise.reject(new Error('Usuário não autenticado'));
    }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "text/plain");
    return fetch("http://localhost:3000/print", {
      method: "POST",
      headers: myHeaders,
      body: zebraCode,
      redirect: "follow"
    })
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  }
}
